import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle, css } from 'styled-components';
import history from '../../core/history';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import Header from '../HeaderV2';
import AppFooter from '../AppFooter/AppFooter';
import { DESKTOP_FAT_GUTTER, DESKTOP_THIN_GUTTER, MOBILE_GUTTER } from '../../constants/layout';
import {
  biggerThanOrEqualTo,
  smallerThanOrEqualTo,
  breakpoints,
} from '../../core/util/styledComponents';

const StyledLayoutRoot = styled.div`
  background-color: ${props => props.backgroundColor};
  height: 100%;
`;

const BodyBackgroundColor = createGlobalStyle`
  body {
    background-color: ${props => props.backgroundColor};
  }
`;

const SecondHeader = styled.div`
  color: ${colors.blueMonday};
  display: flex;
  justify-content: center;
  background-color: ${colors.white};
  text-transform: uppercase;
  font-size: ${fontSize.mediumSmall};
  padding: 16px 0;
  font-family: ${fontFamily.bold};
  border-top: 1px solid ${colors.greyHounds};
  border-bottom: 1px solid ${colors.greyHounds};
`;

const Content = styled.div`
  ${props => css`
    max-width: ${props.fullWidth ? 'inherit' : `${breakpoints.lg}`};
  `};
  overflow: hidden;
  ${props =>
    props.desktopPadded
      ? css`
          ${biggerThanOrEqualTo.md`
      padding: 0 ${DESKTOP_THIN_GUTTER}px;
    `}
          ${biggerThanOrEqualTo.lg`
      padding: 0 ${DESKTOP_FAT_GUTTER}px;
    `}
        `
      : css``};
  ${props =>
    props.mobilePadded
      ? css`
          ${smallerThanOrEqualTo.md`
      padding: 0 ${MOBILE_GUTTER}px;
    `}
        `
      : css``};
  margin: 0 auto;
`;

class Layout extends Component {
  render() {
    const {
      children,
      hideFooter,
      hideHeader,
      secondTitle,
      mobilePadded,
      desktopPadded,
      fullWidth,
      backgroundColor,
      ContentComponent,
      className,
    } = this.props;

    const LayoutContent = ContentComponent || Content;
    return (
      <StyledLayoutRoot backgroundColor={backgroundColor} className={className}>
        <BodyBackgroundColor backgroundColor={backgroundColor} />
        {!hideHeader && <Header {...this.props} />}
        {secondTitle && <SecondHeader>{secondTitle}</SecondHeader>}
        <LayoutContent
          mobilePadded={mobilePadded}
          desktopPadded={desktopPadded}
          fullWidth={fullWidth}
        >
          {children}
        </LayoutContent>
        {!hideFooter && <AppFooter />}
      </StyledLayoutRoot>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.bool])),
  ]).isRequired,
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  handleLogoOnClick: PropTypes.func,
  ContentComponent: PropTypes.any,
  backgroundColor: PropTypes.string,
  secondTitle: PropTypes.string,
  mobilePadded: PropTypes.bool,
  desktopPadded: PropTypes.bool,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  title: PropTypes.string,
  logoOnly: PropTypes.bool,
  selectedTabId: PropTypes.string,
};

Layout.defaultProps = {
  handleLogoOnClick: () => history.push('/'),
  backgroundColor: colors.whiteGrey, // default header background color, so over-scroll looks nice
  mobilePadded: true,
  desktopPadded: true,
  logoOnly: false,
  selectedTabId: null,
};

export default Layout;
